import { IPlayerGame } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";
import { GetPlayersNextGamesPayload } from '@grassrootly/api/gateways';

export const GetPlayersNextGamesAlt = async ({
  date_from,
  pid,
}: GetPlayersNextGamesPayload): Promise<IPlayerGame[]> => {
  const nextGames = withErrorCheck(
    // @ts-ignore
    await server.rpc("players_next_games", { date_from, pid })
  );

  if (!nextGames) return [];

  (nextGames as any[]).forEach((x) => {
    x.player_attended = x.attended;
    delete x.attended;
    x.player_id = pid;
  });

  return nextGames;
};


